import { slice } from 'lodash/fp';

import { MappedQuestion } from '../../../../../types/question';

type GetReducedInitialItems = {
  isOpen: boolean;
  items: MappedQuestion[];
  initialVisible?: number;
};

const getVisibleAccordionItems = ({ isOpen, items, initialVisible }: GetReducedInitialItems) => {
  if (!initialVisible) {
    return items;
  }
  const visibleItems = slice(0, initialVisible, items);
  return isOpen ? items : visibleItems;
};

export default getVisibleAccordionItems;
